'use client';

import { FC, useState } from 'react';
import { RemoveFirmRoleAssignmentDialogProps } from './RemoveFirmRoleAssignmentDialog.types';
import { Dialog, Button, ButtonGroup, Text } from '@/_components';

export const RemoveFirmRoleAssignmentDialog: FC<
  RemoveFirmRoleAssignmentDialogProps
> = ({
  isOpen,
  onClose,
  removeFirmRoleAssignment,
  firmRoleAssignment,
  firmRole,
  userName,
}) => {
  const [isLoading, setLoading] = useState<boolean>(false);

  if (!firmRole || !firmRoleAssignment) return null;

  const onConfirm = async () => {
    if (
      typeof firmRole?.id !== 'number' ||
      typeof firmRoleAssignment?.user_id !== 'number'
    ) {
      return;
    }

    try {
      setLoading(true);

      await removeFirmRoleAssignment(firmRole?.id, firmRoleAssignment?.user_id);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      onClose();
    }
  };
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      isNarrow={true}
      title="Remove firm role assignment"
    >
      <Dialog.Content>
        <Text>
          Are you sure you want to remove <b>{firmRole?.role_name}</b> from{' '}
          <b>{userName}</b>?
        </Text>
      </Dialog.Content>
      <Dialog.Footer>
        <ButtonGroup align="right">
          <Button
            intent="secondary"
            value="Cancel"
            isDisabled={isLoading}
            onClick={onClose}
          />
          <Button
            intent="danger"
            value="Confirm"
            isDisabled={isLoading}
            isLoading={isLoading}
            onClick={onConfirm}
          />
        </ButtonGroup>
      </Dialog.Footer>
    </Dialog>
  );
};
